export default __webpack_public_path__ + "static/media/pngwing.com.d99df108.png";